"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIconGetter = void 0;
const react_1 = __importDefault(require("react"));
const defaultIconGetter = (option) => {
    return option &&
        (typeof option['icon'] === 'string' ||
            react_1.default.isValidElement(option['icon']))
        ? option['icon']
        : null;
};
exports.defaultIconGetter = defaultIconGetter;
//# sourceMappingURL=defaultIconGetter.js.map